import styled from '@emotion/styled';
import { type EntityEvent, EntityEventType } from '@racemap/sdk/schema/entityEvents';
import { Tag } from 'antd';
import type { FC } from 'react';
import { IconFail, IconInfo, IconOk } from 'src/components/Icon';

interface Props {
  event: EntityEvent;
}

export const FirmwareUpdateResultConfig: Partial<
  Record<
    EntityEventType,
    {
      label: string;
      icon: JSX.Element;
      color: string;
      shortLabel?: string;
    }
  >
> = {
  [EntityEventType.FIRMWARE_UPDATE_COMMAND_CONFIRMED]: {
    label: 'Update Command Confirmed',
    icon: <IconInfo />,
    color: 'processing',
  },
  [EntityEventType.FIRMWARE_UPDATE_COMMAND_REFUSED]: {
    label: 'Update Command Refused',
    icon: <IconFail />,
    color: 'red',
  },
  [EntityEventType.FIRMWARE_UPDATE_PROCESS_CANCELED_BY_BACKEND]: {
    label: 'Update Command Canceled',
    icon: <IconFail />,
    color: 'red',
  },
  [EntityEventType.FIRMWARE_UPDATE_PROCESS_REFUSED_LOW_BATTERY]: {
    label: 'Update Refused (Low Battery)',
    icon: <IconFail />,
    color: 'red',
  },

  [EntityEventType.FIRMWARE_DOWNLOAD_STARTING]: {
    label: 'Download Started',
    icon: <IconInfo />,
    color: 'processing',
  },
  [EntityEventType.FIRMWARE_DOWNLOAD_SUCCESS]: {
    label: 'Download Completed',
    icon: <IconInfo />,
    color: 'processing',
  },
  [EntityEventType.FIRMWARE_DOWNLOAD_FAILED]: {
    label: 'Download Failed',
    icon: <IconFail />,
    color: 'red',
  },

  [EntityEventType.FIRMWARE_DEVICE_UPDATE_STARTING]: {
    label: 'Device Update Started',
    icon: <IconInfo />,
    color: 'processing',
  },
  [EntityEventType.FIRMWARE_DEVICE_UPDATE_SUCCESS]: {
    label: 'Device Update Successful',
    icon: <IconOk />,
    color: 'green',
  },
  [EntityEventType.FIRMWARE_DEVICE_UPDATE_FAILED]: {
    label: 'Device Update Failed',
    icon: <IconFail />,
    color: 'red',
  },
  [EntityEventType.FIRMWARE_DEVICE_UPDATE_NOT_START_LOW_BATTERY]: {
    label: 'Update Not Started (Low Battery)',
    icon: <IconFail />,
    color: 'red',
  },
};

export const FirmwareUpdateResult: FC<Props> = ({ event }) => {
  const { eventType } = event;
  const { label, icon, color } = FirmwareUpdateResultConfig[eventType] ?? {};

  return (
    <FirmwareUpdateResultContainer>
      <Tag color={color} icon={icon}>
        <Label>{label}</Label>
      </Tag>
    </FirmwareUpdateResultContainer>
  );
};

const FirmwareUpdateResultContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-end;
`;

const Label = styled.div`
  display: inline-flex;
  align-items: center;
  padding-left: 4px;
`;
